import type { ReactNode } from 'react';
import React from 'react';
import { Flex } from '@balance-web/flex';

export const Header = ({ children }: { children: ReactNode }) => {
  return (
    <Flex
      gap="xsmall"
      justifyContent="space-between"
      paddingTop="medium"
      paddingX="large"
    >
      {children}
    </Flex>
  );
};
